import { rem } from 'polished'
import styled from 'styled-components'

export const AuditLogRecordLabelStyled = styled.div`
  padding: 0 ${rem(16)};
  border-radius: 0 ${rem(16)} ${rem(16)} 0;
  font-weight: ${(props) => props.theme.fontWeights.semibold};
  font-size: ${(props) => props.theme.fontSizes.body2};
`
